import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["width"]
const _hoisted_2 = ["width"]
const _hoisted_3 = ["width"]
const _hoisted_4 = ["width"]
const _hoisted_5 = {
  key: 0,
  class: "text-container"
}
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 1,
  class: "text-container second-container"
}
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "editable-row" }
const _hoisted_10 = { class: "leftSide" }
const _hoisted_11 = { class: "editable-row" }
const _hoisted_12 = { class: "leftSide" }
const _hoisted_13 = { class: "editable-row" }
const _hoisted_14 = { class: "last leftSide" }
const _hoisted_15 = { class: "suppression-container" }
const _hoisted_16 = { class: "confirm-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_DataList = _resolveComponent("DataList")!
  const _component_EditableInput = _resolveComponent("EditableInput")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_ModalCard = _resolveComponent("ModalCard")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalCardYesNo = _resolveComponent("ModalCardYesNo")!
  const _component_SuccessModal = _resolveComponent("SuccessModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Modal, { onCancel: _ctx.cancel }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalCard, {
          onCancel: _ctx.cancel,
          headerTitle: _ctx.$t('modale.my.account.title'),
          withoutBotNav: true,
          "active-validate": false,
          id: "loadingdiv"
        }, {
          default: _withCtx(() => [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_content_loader, {
                  key: 0,
                  width: _ctx.width,
                  height: "300"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("rect", {
                      x: "2",
                      y: "10",
                      rx: "4",
                      ry: "4",
                      width: _ctx.width/3,
                      height: "20"
                    }, null, 8, _hoisted_1),
                    _createElementVNode("rect", {
                      x: "2",
                      y: "35",
                      rx: "4",
                      ry: "4",
                      width: _ctx.width,
                      height: "116"
                    }, null, 8, _hoisted_2),
                    _createElementVNode("rect", {
                      x: "2",
                      y: "170",
                      rx: "4",
                      ry: "4",
                      width: _ctx.width/3,
                      height: "20"
                    }, null, 8, _hoisted_3),
                    _createElementVNode("rect", {
                      x: "2",
                      y: "195",
                      rx: "4",
                      ry: "4",
                      width: _ctx.width,
                      height: "76"
                    }, null, 8, _hoisted_4)
                  ]),
                  _: 1
                }, 8, ["width"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (this.tableData1.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("h3", _hoisted_6, [
                          _createTextVNode(_toDisplayString(_ctx.$t('modale.my.account.personal.informations')) + " ", 1),
                          _createVNode(_component_ReglePastille, { cle: "monCompte.champsEnLectureSeule" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DataList, {
                    data: this.tableData1
                  }, null, 8, ["data"]),
                  (this.tableData2.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("h3", _hoisted_8, _toDisplayString(_ctx.$t('modale.my.account.contact.title')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_DataList, {
                    class: "last",
                    data: this.tableData2
                  }, null, 8, ["data"]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createTextVNode(_toDisplayString(_ctx.$t('modale.my.account.contact.password.label')) + " ", 1),
                      _createVNode(_component_ReglePastille, { cle: "monCompte.motDePasseRegles" })
                    ]),
                    _createVNode(_component_EditableInput, {
                      "model-value": _ctx.mdp,
                      "is-saving": _ctx.isPhoneSaving,
                      mdp: true,
                      onSave: _ctx.sauvegarderMdp,
                      class: "rightSide"
                    }, null, 8, ["model-value", "is-saving", "onSave"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('modale.my.account.contact.phone')), 1),
                    _createVNode(_component_EditableInput, {
                      class: "rightSide",
                      "model-value": this.profil.telephoneFixe,
                      onSave: _ctx.savePhone,
                      "is-saving": _ctx.isPhoneSaving
                    }, null, 8, ["model-value", "onSave", "is-saving"])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('modale.my.account.contact.mobile')), 1),
                    _createVNode(_component_EditableInput, {
                      class: "rightSide",
                      "model-value": this.profil.telephonePortable,
                      onSave: _ctx.saveMobilePhone,
                      "is-saving": _ctx.isMobilePhoneSaving
                    }, null, 8, ["model-value", "onSave", "is-saving"])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_ReglePastille, { cle: "monCompte.suppressionCompte" }),
                    _createVNode(_component_ButtonBlue, {
                      className: "redBtn btn-suppression",
                      text: _ctx.isDeleteAccountRequested ? _ctx.$t('modale.my.account.delete.requested') : _ctx.$t('modale.my.account.delete.request'),
                      onClick: _ctx.openDeleteConfirm,
                      disabled: _ctx.isDeleteAccountRequested
                    }, null, 8, ["text", "onClick", "disabled"])
                  ])
                ], 64))
          ]),
          _: 1
        }, 8, ["onCancel", "headerTitle"])
      ]),
      _: 1
    }, 8, ["onCancel"]),
    (_ctx.showDeleteConfirm)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onCancel: _ctx.closeDeleteConfirm
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModalCardYesNo, {
              headerTitle: _ctx.$t('modale.my.account.delete.confirm.title'),
              "active-validate": true,
              onYes: _ctx.confirmDeleteAccount,
              onNo: _ctx.closeDeleteConfirm,
              onCancel: _ctx.closeDeleteConfirm
            }, {
              default: _withCtx(() => [
                _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t('modale.my.account.delete.confirm.message')), 1)
              ]),
              _: 1
            }, 8, ["headerTitle", "onYes", "onNo", "onCancel"])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteSuccess)
      ? (_openBlock(), _createBlock(_component_SuccessModal, {
          key: 1,
          title: '',
          subtitle: _ctx.$t('modale.my.account.delete.success.message'),
          onCancel: _ctx.closeDeleteSuccess
        }, null, 8, ["subtitle", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}